module.exports = __webpack_public_path__ + "img/ic-lock.7152f828.svg";